import normalizer from '@cordel/helpers/form/schema';

// eslint-disable-next-line import/no-extraneous-dependencies
import {
  SORT_METHODS,
  DENIED,
  ACCEPTED,
  TITLES,
  IDENTIFIERS,
} from './status';

import {
  FILTERS,
  ALWAYS_VISIBLE,
} from './sections';

import {
  SEARCH,
  STATUS,
  SORT,
} from './fields';

export default function schema() {
  return normalizer({
    sections: {
      [FILTERS]: {},
    },

    fields: {
      [SEARCH]: {
        section: FILTERS,
        subsection: ALWAYS_VISIBLE,
        type: 'input',
        label: 'Pesquisar',
        labelless: true,
        placeholder: 'Pesquisar...',
        size: 4,
        icon: 'search',
      },
      [STATUS]: {
        section: FILTERS,
        subsection: ALWAYS_VISIBLE,
        type: 'select',
        label: 'Status',
        labelless: true,
        placeholder: 'Status',
        size: 4,
        options: [ACCEPTED, DENIED]
          .map(item => ({
            label: TITLES[item],
            value: String(IDENTIFIERS[item]),
          })),
      },
      [SORT]: {
        section: FILTERS,
        subsection: ALWAYS_VISIBLE,
        type: 'select',
        label: 'Ordenação',
        labelless: true,
        placeholder: 'Ordenação',
        size: 4,
        options: Object.values(SORT_METHODS),
        value: SORT_METHODS.invitation_sent_at_desc.value,
      },
    },
  });
}
